import useHttpMutation from 'data/firestore/useHttpMutation';
import { Templatepartial } from 'data/firestore/agent/templatepartial/types';

export default () => useHttpMutation<Partial<Omit<Templatepartial, 'id' | 'createdAt'>>, Templatepartial>({
    method: 'PUT',
    server: process.env.REACT_APP_BASE_URL,
});
